if (!customElements.get('l4-collection-toolbar')) {
  customElements.define('l4-collection-toolbar', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.sticky === 'false') return;
      this.initialize = () => {
        if (!this.isConnected || this.header) return;
        this.header = document.getElementById('site-header');
        this.bar = this.querySelector('.l4-collection-toolbar__bar');
        if (!this.header || !this.bar) return;
        document.body.classList.add('l4-collection-scroll');

        this.placeholder = document.createElement('div');
        this.placeholder.hidden = true;
        this.placeholder.setAttribute('aria-hidden', 'true');
        this.header.before(this.placeholder);
        this.lastScroll = Math.max(0, window.scrollY);
        this.direction = 'down';
        this.activated = false;
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        };
        this.onFocus = () => {
          if (this.activated) {
            this.direction = 'up';
            this.schedule();
          }
        };
        this.onSectionChange = () => {
          if (document.getElementById('site-header') !== this.header) {
            this.disconnectedCallback();
            this.initialize();
          } else {
            this.schedule();
          }
        };
        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', this.schedule);
        window.addEventListener('pageshow', this.schedule);
        document.addEventListener('shopify:section:load', this.onSectionChange);
        this.header.addEventListener('focusin', this.onFocus);
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.header);
        this.resizeObserver.observe(this.bar);
        this.update();
      };
      customElements.whenDefined('main-header').then(this.initialize);
    }

    update() {
      if (document.body.classList.contains('sidebar-opened')) return;
      const scroll = Math.max(0, window.scrollY);
      const delta = scroll - this.lastScroll;
      if (Math.abs(delta) >= 5) {
        this.direction = delta > 0 ? 'down' : 'up';
        this.lastScroll = scroll;
      }

      const headerHeight = this.header.offsetHeight;
      const toolbarTop = this.getBoundingClientRect().top;
      if (toolbarTop <= 0) this.activated = true;
      const headerOrigin = this.placeholder.hidden ?
        this.header.getBoundingClientRect().top + scroll :
        this.placeholder.getBoundingClientRect().top + scroll;
      if (scroll <= headerOrigin) this.activated = false;

      const pinned = this.activated;
      const wasPinned = this.header.classList.contains('l4-collection-header--pinned');
      const revealed = pinned && this.direction === 'up';
      const stuck = toolbarTop <= (revealed ? headerHeight : 0);
      // Reserve both elements' natural space before making them fixed.
      this.placeholder.style.height = `${headerHeight}px`;
      this.placeholder.hidden = !pinned;
      // The first pin moves an already scrolled-away header to fixed positioning.
      // Hide it immediately; animate only later direction changes.
      this.header.classList.toggle('l4-collection-header--animate', pinned && wasPinned);
      this.header.classList.toggle('l4-collection-header--pinned', pinned);
      this.header.classList.toggle('l4-collection-header--revealed', revealed);
      this.style.height = stuck ? `${this.bar.offsetHeight}px` : '';
      this.style.setProperty('--l4-toolbar-header-height', revealed ? `${headerHeight}px` : '0px');
      this.classList.toggle('l4-collection-toolbar--stuck', stuck);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      if (!this.header) return;
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
      document.removeEventListener('shopify:section:load', this.onSectionChange);
      this.header.removeEventListener('focusin', this.onFocus);
      this.resizeObserver?.disconnect();
      this.header.classList.remove('l4-collection-header--pinned', 'l4-collection-header--revealed', 'l4-collection-header--animate');
      this.placeholder?.remove();
      document.body.classList.remove('l4-collection-scroll');
      this.header = null;
      this.style.height = '';
      this.classList.remove('l4-collection-toolbar--stuck');
    }
  });
}
